import axios from 'axios';
import { Prequal } from '../schema';
import {
  isProduction,
  PROD_TRIDENT_API_URL,
  QA_TRIDENT_API_URL,
  SEND_CUSTOM_ITERABLE_EVENT_PATH,
  PROD_SEND_CUSTOM_ITERABLE_EVENT_API_KEY,
  QA_SEND_CUSTOM_ITERABLE_EVENT_API_KEY,
} from '../constants';

interface EventData {
  [key: string]: any;
}

interface SendCustomEventParams {
  email: string;
  eventName: string;
  eventData?: EventData;
  isLendAPI?: boolean;
  applicationId?: string | null;
  prodTesting?: boolean;
  e2eProdTesting?: boolean;
}

interface LendAPIData {
  desiredMonthlyPayment?: number;
  purchasingPower?: number;
  applicationId?: string;
}

interface SendCustomEventResponse {
  success: boolean;
  approvalStatus?: string;
  lendAPIData?: LendAPIData;
}

export const sendCustomEventToIterable = async ({
  email,
  eventName,
  eventData,
  isLendAPI,
  applicationId,
  prodTesting,
  e2eProdTesting,
}: SendCustomEventParams): Promise<SendCustomEventResponse> => {
  const isProd = isProduction();
  const url = isProd
    ? `${PROD_TRIDENT_API_URL}${SEND_CUSTOM_ITERABLE_EVENT_PATH}`
    : `${QA_TRIDENT_API_URL}${SEND_CUSTOM_ITERABLE_EVENT_PATH}`;
  const apiKey = isProd
    ? PROD_SEND_CUSTOM_ITERABLE_EVENT_API_KEY
    : QA_SEND_CUSTOM_ITERABLE_EVENT_API_KEY;
  try {
    const result = await axios.post(
      url,
      {
        email,
        eventName,
        eventData,
        isLendAPI,
        applicationId,
        prodTesting,
        e2eProdTesting,
      },
      { headers: { 'x-api-key': apiKey } }
    );
    return result.data as SendCustomEventResponse;
  } catch (error: any) {
    console.error('sendCustomEventToIterable | Error:', error);
    return { success: false };
  }
};

export const formatIterablePayload = (prequal: Prequal, overrides: { [key: string]: any }) => {
  const payload = Object.fromEntries(
    Object.entries({
      prequalId: prequal.prequalApplicationId,
      email: prequal.email,
      firstName: prequal.firstName,
      lastName: prequal.lastName,
      boatMake: prequal.boatMake,
      boatModel: prequal.boatModel,
      sellerName: prequal.sellerName,
      sellerEmail: prequal.sellerEmail,
      sellerPartyId: prequal.partyId,
      boatImtId: prequal.imtId,
      sellerType: prequal.sellerType,
      ...overrides,
    }).filter(([, v]) => v !== null && v !== undefined)
  );

  return payload;
};
